import logoTrade from '../assets/img/trade/logo.png'
import logoPop from '../assets/img/pop/logo.png'
import logoSeven from '../assets/img/seven/logo.png'
import logoTradeMark from '../assets/img/trademark/logo.png'
import { Marca, AmbienteResumo } from './estado'

/* A marca vira variáveis CSS na raiz da página. O SCSS do portal lê as mesmas variáveis
   (com a cor do build como reserva), então as telas antigas também trocam de cor. */

export const TRADE_TALENTOS: Marca = {
  id: 0, nome: 'Trade Talentos', corPrincipal: '#e21ae7', corApoio: '#00e6ff', fonte: 'Nunito Sans', ambientes: []
}

// Logo de reserva das marcas que já vêm no portal, para marca cadastrada sem logo.
const LOGOS_DO_PORTAL: Record<string, string> = {
  'trade talentos': logoTrade,
  pop: logoPop,
  seven: logoSeven,
  trademark: logoTradeMark
}

export const FONTES: Record<string, string> = {
  'Nunito Sans': '"Nunito Sans", "Segoe UI", sans-serif',
  Arimo: 'Arimo, Arial, Helvetica, sans-serif',
  Manrope: 'Manrope, "Segoe UI", sans-serif',
  Poppins: 'Poppins, "Segoe UI", sans-serif'
}

export function logoDaMarca(m: Marca, escuro = false): string | null {
  return (escuro && m.logoEscuro) || m.logoClaro || LOGOS_DO_PORTAL[m.nome.trim().toLowerCase()] || null
}

function tradeTalentos(marcas: Marca[]): Marca {
  return marcas.find(m => m.nome.trim().toLowerCase() === 'trade talentos') || TRADE_TALENTOS
}

export function marcaDoAmbiente(marcas: Marca[], ambientes: AmbienteResumo[], ambienteId: number): Marca {
  const a = ambientes.find(x => x.id === ambienteId)
  return (a?.brandId && marcas.find(m => m.id === a.brandId)) || tradeTalentos(marcas)
}

/** Fora de um ambiente: com uma empresa só, a marca dela; com mais de uma, Trade Talentos. */
export function marcaDaCasa(marcas: Marca[], ambientes: AmbienteResumo[]): Marca {
  const usadas = Array.from(new Set(ambientes.map(a => a.brandId || 0)))
  if (usadas.length === 1 && usadas[0]) return marcas.find(m => m.id === usadas[0]) || tradeTalentos(marcas)
  return tradeTalentos(marcas)
}

function rgb(hex: string): number[] {
  const h = hex.replace('#', '')
  return [0, 2, 4].map(i => parseInt(h.substr(i, 2), 16))
}
function luminancia(hex: string): number {
  return rgb(hex).map(v => { const c = v / 255; return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4) })
    .reduce((s, c, i) => s + c * [0.2126, 0.7152, 0.0722][i], 0)
}
export function contraste(a: string, b: string): number {
  const x = luminancia(a), y = luminancia(b)
  return (Math.max(x, y) + 0.05) / (Math.min(x, y) + 0.05)
}
/** Texto branco sempre que for legível (contraste de 3 para 1, o mínimo para texto em negrito);
    escuro só em cor clara, como o amarelo da Seven. */
export function textoSobre(cor: string): string {
  return contraste(cor, '#ffffff') >= 3 ? '#ffffff' : '#1d1600'
}
export function escurecer(hex: string, quanto: number): string {
  return '#' + rgb(hex).map(v => Math.max(0, Math.round(v * (1 - quanto))).toString(16).padStart(2, '0')).join('')
}

const fontesCarregadas = new Set<string>()
function carregarFonte(fonte: string) {
  if (fontesCarregadas.has(fonte) || fonte === 'Nunito Sans') return
  fontesCarregadas.add(fonte)
  const link = document.createElement('link')
  link.rel = 'stylesheet'
  link.href = `https://fonts.googleapis.com/css2?family=${fonte.replace(/ /g, '+')}:wght@400;600;700;800&display=swap`
  document.head.appendChild(link)
}

const VARIAVEIS = ['--np-primaria', '--np-primaria-escura', '--np-apoio', '--np-destaque', '--np-sobre-primaria', '--np-suave', '--np-fonte']

export function aplicarMarca(m: Marca) {
  const r = document.documentElement.style
  r.setProperty('--np-primaria', m.corPrincipal)
  r.setProperty('--np-primaria-escura', escurecer(m.corPrincipal, 0.18))
  r.setProperty('--np-apoio', m.corApoio)
  r.setProperty('--np-destaque', m.corPrincipal)
  r.setProperty('--np-sobre-primaria', textoSobre(m.corPrincipal))
  r.setProperty('--np-suave', `color-mix(in srgb, ${m.corPrincipal} 12%, #ffffff)`)
  r.setProperty('--np-fonte', FONTES[m.fonte] || FONTES['Nunito Sans'])
  carregarFonte(m.fonte)
}

/** Volta ao visual do build (quem desliga o layout novo não fica com a marca pendurada). */
export function limparMarca() {
  const r = document.documentElement.style
  VARIAVEIS.forEach(v => r.removeProperty(v))
}
